import CommandeFormController from './commande.form.controller';

export default {
    bindings: {
        idCommande: '='
    },
    template: require('./commande.form.html'),
    controller: CommandeFormController
};
